import PermissionsInstance from 'modules/permissions/repository';

export const fetchPermissionGroups = (scopeType, scopeId, opts) => PermissionsInstance.getPermissionGroups(scopeType, scopeId, opts);

export const fetchMembersPermissions = (scopeType, scopeId, opts) => PermissionsInstance.getScopeMembersPermissions(scopeType, scopeId, opts);
